import urls from './url';
import Env from './env';
import { sortObj, encodeParams, phoneType } from '../util/base';
import MD5 from 'js-md5';
import storage from 'store';
import axios from 'axios';
import qs from 'qs';
import store from '../redux/store/index';
import {ShowLoading,HideLoading}  from '../redux/actions/loading';
import { Toast } from 'antd-mobile';

const service = axios.create({
  withCredentials: true, // 跨域凭证
  timeout: 10000 // request timeout
})
const Http = {

  data(param = {}) {
    //处理md5加密
    let obj = sortObj(param);
    let url = encodeParams(Object.assign(obj,{sqzlKey:Env.sqzlKey}));
    let md5 = MD5.hex(url);
    return Object.assign(param, { sign: md5 });
  },

  get(param) {
    return this.post(param, 'GET');
  },

  post(param, type) {
    let user = storage.get('user') || {
      token: '',
    };
    let channel =  storage.get('channel') || '';
    return new Promise((resolve, reject) => {
      const u = navigator.userAgent
      service({
        url: `${param.url}`,
        method: type || 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'IZU-SESSION-TOKEN': user.token,
        // 设备信息
          'IZU-DEVICE-TYPE': '6', //设备类型
          'IZU-APP-VERSION': Env.version, //应用程序版本号
          'IZU-APP-SHORTVERSION':  Env.short_version, //应用程序内部版本号 
          'IZU-REGISTER-CHANNEL': channel || 'H5', //注册渠道
          'IZU-DEVICE-MODEL': '', //设备型号名称
          'IZU-DEVICE-OS-TYPE': phoneType(u), //设备操作系统类型
          'IZU-DEVICE-OS-VERSION': '', //设备操作系统版本
          'IZU-DEVICE-CHANNEL': 'h5',
          'IZU-ORDER-CHANNEL': channel || 'fromH5',
          'IZU-DEVICE-BRAND': ''   //设备厂商品牌
        },
        data: qs.stringify(this.data(param.data)),
        params: type === 'GET' ? this.data(param.data) : {},
        responseType: 'json'
      }).then(res => {
         resolve(res)
      }).catch(err => {
        this.codeError(typeof err === 'object' ? '' : err)
        reject(err)
      })
    })

  },
  codeError(msg) {
    try {
      if (msg === '') {
        return
      }
      store.dispatch(HideLoading({loading:false}))
      Toast.info(msg, 1.5, null, false)
    } catch (error) {
      console.log(error)
    }
  }
}

// http request 拦截器
service.interceptors.request.use(
  res => {
    store.dispatch(ShowLoading({loading:true}))
    return res
  },
  error => {
    return Promise.reject(error)
  }
)

// http response 拦截器
service.interceptors.response.use(
  response => {
    store.dispatch(HideLoading({loading:false}))
    if (response.status === 200 && response.data.code === 0) {
      return response.data
    } else if (response.status === 200 && response.data.code === 401) {
      let url = window.location.href;
      // if (url.indexOf('couponList') > -1) {
      //   return window.location.replace('/login?type=refresh')
      // }
      // if (url.indexOf('routeOrderList') > -1) {
      //   return window.location.replace('/login?type=refresh')
      // }
        window.location.href = '/login'
        return Promise.reject('')
    } else if (response.status === 200 && response.data.code === 100) {
        if (response.config.url === '/api/payment/pay/v1/result/query.json') {
          return {code: 0, msg: '', data: {}}
        }
        return Promise.reject(response.data.msg)
    } else if (response.status === 200 && response.data.code === 102) {
      return {code: 0, msg: '支付成功', type: 'wechat'}
    } else if (response.status === 200 && response.data.code === 11004) {
        return {code: 0, msg: '支付成功', type: 'wechat'}
    }
    else if (response.status === 200 && response.data.code === 113) {
        Toast.info(response.data.msg, 1.5, null, false);
        window.history.go(-1);
        return Promise.reject('');
    }
    else if (
        response.status === 200
        && response.config.url === '/api/payment/bank/v1/bind.json'
        && response.data.code !== 0
    ) {
        Toast.info(response.data.msg, 1.5, null, false);
        window.history.go(-1);
        return Promise.reject('');
    }
    else {
        return Promise.reject(response.data.msg)
    }
  },
  err => {
    return Promise.reject(err)
  }
)
export {
  Http,
  urls,
  service
};